export const PHASE_1_SCREEN = 'PHASE_1_SCREEN';
export const PHASE_2_SCREEN = 'PHASE_2_SCREEN';
export const FWU_CHECK_SCREEN = 'FWU_CHECK_SCREEN';
export const FWU_SCREEN = 'FWU_SCREEN';
export const NO_ERRORS_SCREEN = 'NO_ERRORS_SCREEN';
export const MARKET_SCREEN = 'MARKET_SCREEN';
export const MARKET_QURE_SCREEN = 'MARKET_QURE_SCREEN';
export const MARKET_NON_QURE_SCREEN = 'MARKET_NON_QURE_SCREEN';
export const RESET_SCREEN = 'RESET_SCREEN';
export const FINISH_SCREEN = 'FINISH_SCREEN';
export const DAMAGE_CHECK_SCREEN = 'DAMAGE_CHECK_SCREEN';
export const REMOVE_STICK_SCREEN = 'REMOVE_STICK_SCREEN';
export const FITTING_CONSUMABLES_CHECK_SCREEN = 'FITTING_CONSUMABLES_CHECK_SCREEN';
export const FITTING_CONSUMABLES_SOLVED = 'FITTING_CONSUMABLES_SOLVED';
export const SELECT_ISSUE_SCREEN = 'SELECT_ISSUE_SCREEN';
export const CONSENT_SCREEN = 'CONSENT_SCREEN';
export const RUNNING_SCREEN = 'RUNNING_SCREEN';
export const RUNNING_FAIL_SCREEN = 'RUNNING_FAIL_SCREEN';
export const ADAPTOR_MSG_SCREEN = 'ADAPTOR_MSG_SCREEN';
export const QUESTIONNAIRE_MARKET_SCREEN = 'QUESTIONNAIRE_MARKET_SCREEN';
export const HOLDER_DETECTED_SCREEN = 'HOLDER_DETECTED_SCREEN';
export const CLEANING_GUIDE_SCREEN = 'CLEANING_GUIDE_SCREEN';
export const POST_CLEANING_SCREEN = 'POST_CLEANING_SCREEN';
export const CLEANING_CONTACTS_SCREEN = 'CLEANING_CONTACTS_SCREEN';
export const CHARGING_ISSUE_SCREEN = 'CHARGING_ISSUE_SCREEN';
export const MULTIPLE_ISSUES_SCREEN = 'MULTIPLE_ISSUES_SCREEN';
export const PARTIAL_FINISH_ELIGIBILITY_SCREEN = 'PARTIAL_FINISH_ELIGIBILITY_SCREEN';
export const PARTIAL_FINISH_ADAPTOR_SCREEN = 'PARTIAL_FINISH_ADAPTOR_SCREEN';
